import { createStore } from "vuex";

import actions from "./actions.js";
import getters from "./getters.js";
import mutations from "./mutations.js";

export const initialState = () => {
  return {
    adminPreferences: [],
    accessRole: null,
    accessRoleError: null,
    accessRoleLoading: false,
    accountingCategories: [],
    accountingClasses: {},
    appointment: null,
    admins: [],
    backgroundTasks: [],
    backgroundTasksClockSkewMs: 0,
    batches: {},
    batchItems: {},
    breadcrumbs: [],
    callRail: {
      config: {
        step: 0,
        ready: false,
        enabled: null,
        persisted: null,
        api_key: null,
        account_id: null,
        company_id: null,
        webhooks_integration_id: null,
        signature_key: null,
        updated_at: null
      },
      accounts: [],
      companies: [],
      warnings: []
    },
    confirmChanges: {
      show: false,
      resolve: null,
      reject: null,
      message: "You cannot undo these changes. Are you sure?",
      title: "Confirm",
      className: "",
      confirmInputValue: ""
    },
    componentTypes: [],
    crewMembers: [],
    currentAdmin: null,
    currentCustomFormTemplate: null,
    currentDepartment: null,
    currentInvoice: null,
    currentMembershipProgram: null,
    currentQuote: null,
    currentTask: null,
    currentUser: null,
    currentUserAddresses: [],
    currentWarrantyProgram: null,
    customerEquipment: [],
    customizations: null,
    dashboardData: {},
    dashboardFilters: {},
    dashboardLoading: true,
    department: null,
    departmentPriceSheets: [],
    departments: [],
    discounts: [],
    equipmentTypes: [],
    importVendors: [],
    importedDataWarning: {
      show: false,
      record: null,
      context: null,
      resolve: null,
      reject: null
    },
    jobStatusFinalWarning: {
      show: false,
      record: null,
      context: null,
      resolve: null,
      reject: null
    },
    inventoryLocations: [],
    inventoryParts: [],
    invoices: {},
    leadSources: [],
    leadTypes: [],
    fetchingTenant: false,
    myTodos: {
      count: 0,
      grouped: {},
      source: []
    },
    googleTimezoneAPIKey: "",
    importDatasets: null,
    integrations: null,
    zapierIntegrations: null,
    broccoliConfig: null,
    campDigitalConfig: null,
    jbWarranties: {
      config: {
        contact_first_name: null,
        contact_last_name: null,
        ein: null,
        state_license_number: null,
        dealer_id: null,
        api_key: null,
        persisted: false,
        verified_at: null,
        enabled: false
      }
    },
    job: {},
    membershipDashboardFilters: {},
    membershipDashboardGrowthChart: null,
    membershipDashboardGrowthChartLoading: false,
    membershipDashboardLoading: false,
    membershipDashboardRevenueComparison: null,
    membershipDashboardRevenueComparisonLoading: false,
    membershipDashboardSummary: null,
    membershipPrograms: [],
    mergeAccounts: {
      destination: {
        customer: null,
        options: []
      },
      duplicate: {
        customer: null,
        options: []
      }
    },
    partCategories: [],
    partCategoryTree: [],
    paymentMethods: [],
    paymentMethodsSettings: null,
    pendingNotificationCount: 0,
    priceSheets: [],
    receivers: [],
    taskHistory: [],
    timeCardEmployees: [],
    scheduleBoardFilters: {
      department_ids: null,
      start: new Date()
    },
    serviceCategories: [],
    jobStatuses: [],
    serviceFinance: {
      config: {
        dealer_id: "",
        api_key: "",
        enabled: false,
        persisted: false
      }
    },
    dialpad: {
      config: {
        persisted: false,
        status: "not_connected"
      }
    },
    ringCentral: {
      config: {
        api_key: "",
        account_id: "",
        persisted: false,
        enabled: false,
        updated_at: ""
      }
    },
    staxPayments: {
      config: {
        web_id: null,
        api_key: null,
        ach_enabled: true,
        card_savable: true,
        card_readers: false,
        persisted: false,
        enabled: false
      }
    },
    taskCategories: [],
    taskCategoryTree: [],
    tasks: [],
    tasksTree: null,
    taxability: {
      companyTaxZones: [],
      companyTaxExemptionReasons: []
    },
    tenant: null,
    tenantCalls: [],
    tenantCustomizations: {},
    technicians: [],
    techniciansForJob: [],
    transactions: [],
    timezones: [
      {
        value: "Eastern Time (US & Canada)",
        label: "Eastern Time (US & Canada)"
      },
      {
        value: "Central Time (US & Canada)",
        label: "Central Time (US & Canada)"
      },
      {
        value: "Mountain Time (US & Canada)",
        label: "Mountain Time (US & Canada)"
      },
      {
        value: "Pacific Time (US & Canada)",
        label: "Pacific Time (US & Canada)"
      }
    ],
    timeline: {
      start_date: "",
      events_fetched_at: "",
      events: [],
      resources: [],
      filters: {
        jobStatusIds: [] as string[],
        statuses: [] as string[],
        departmentIds: [] as number[],
        serviceCategoryIds: [] as number[]
      }
    },
    vendors: [],
    warrantyPrograms: []
  };
};

const store = createStore({
  state: initialState(),
  actions,
  getters,
  mutations
});

export default store;
